import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as React from 'react'; // statics handler

import hoistStatics from 'hoist-non-react-statics';
var language = 'pt';
var id = 0;
var subscribes = {};
var translations = {};
export function subscribe(cb) {
  var newId = id;
  subscribes[newId] = cb;
  id += 1;
  return newId;
}
export function unsubscribe(id) {
  delete subscribes[id];
}

function triggerSubscriptions() {
  Object.keys(subscribes).forEach(function (id) {
    new Promise(function (resolve, reject) {
      subscribes[id]();
      resolve();
    }).then();
  });
}

export function setDefaultLanguage(lang) {
  language = lang;
}
export function setDefaultTranslations(userTranslations) {
  if (Object.keys(translations).length !== 0) {
    setTranslations(userTranslations);
    return;
  }

  translations = userTranslations;
}
export function setTranslations(userTranslations) {
  translations = userTranslations;
  triggerSubscriptions();
}
export function setLanguage(lang) {
  language = lang;
  triggerSubscriptions();
}
export function getLanguage() {
  return language;
}
export function t(path, args) {
  var translationKeys = path.split('.');
  var translation = '';
  var translationObj = translations[language];
  translationKeys.forEach(function (key) {
    var temp = translationObj[key];

    if (typeof translationObj[key] === 'object') {
      translationObj = translationObj[key];
    }

    if (typeof temp === 'string') {
      translation = temp;
    }
  });

  if (translation) {
    if (args) {
      Object.keys(args).forEach(function (key) {
        translation = translation.replace("{".concat(key, "}"), args ? args[key] : '');
      });
    }
  } else {
    return path;
  }

  return translation;
}
export function translate(Component) {
  var TranslatedComponet =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(TranslatedComponet, _React$Component);

    function TranslatedComponet() {
      _classCallCheck(this, TranslatedComponet);

      return _possibleConstructorReturn(this, _getPrototypeOf(TranslatedComponet).apply(this, arguments));
    }

    _createClass(TranslatedComponet, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;

        this.id = subscribe(function () {
          return _this.forceUpdate();
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        unsubscribe(this.id);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, _extends({}, this.props, {
          t: t
        }));
      }
    }]);

    return TranslatedComponet;
  }(React.Component);

  return hoistStatics(TranslatedComponet, Component);
}
export default {
  setDefaultLanguage: setDefaultLanguage,
  setLanguage: setLanguage,
  setDefaultTranslations: setDefaultTranslations,
  setTranslations: setTranslations,
  translate: translate,
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  t: t
};